// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { createOrUpdate, $delete, get, list, listVersions } from "./operations.js";
export type {
  IndexesCreateOrUpdateOptionalParams,
  IndexesDeleteOptionalParams,
  IndexesGetOptionalParams,
  IndexesListOptionalParams,
  IndexesListVersionsOptionalParams,
} from "./options.js";
